import { EmailControl, FormCol, FormContext, useScopedSelector } from 'ia-react-core';
import React, { ClipboardEvent, FC, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmailProps {
  mailType: string;
  disableFlag: string;
  required?: boolean;
}

const Email: FC<EmailProps> = ({ mailType, disableFlag, required }) => {
  const { t } = useTranslation('PersonalInformationsFormPage');
  const { setControlValue } = useContext(FormContext);

  const type = `emails.${mailType}`;
  const typeConfirm = `emails.${mailType}Confirm`;
  const email: string = useScopedSelector(`/App.features.personalInformation.info.${type}`);
  const isEmailDisabled: boolean = useScopedSelector(`/App.features.personalInformation.info.emails.behaviours.${disableFlag}`);
  const notRequired = email === undefined || email === null || email === '';

  return (
    <>
      <FormCol label={t(`emails.${mailType}Label`)}>
        <EmailControl onChange={() => setControlValue(typeConfirm, '')} name={type} required={required} disabled={isEmailDisabled} />
      </FormCol>
      <FormCol label={t(`emails.${mailType}ConfirmLabel`)}>
        <EmailControl
          name={typeConfirm}
          disabled={isEmailDisabled}
          onPaste={(event: ClipboardEvent) => event.preventDefault()}
          validators={ValidatorsConfirm(email)}
          validationMessages={{ isEqualToEmail: t('emails.emailConfirmation') }}
          required={!notRequired}
        />
      </FormCol>
    </>
  );
};

const ValidatorsConfirm = (email: string) => useMemo(() => ({
  isEqualToEmail: (value: string) => (value === '' || value === null || email === '' || email === null || value === email),
}), [email]);

export default Email;
